export class MetadatiProtocolloGescorVO {
  numero: string;

  anno: number;

  data: string;

  tipo: string;

  tipoAbbreviato: string;
}
